<template>
  <right-panel  :datas="connects" ref="rightPanel" @onClose="onCloseChange()">
    <div slot="header">
      <translate>Change Password</translate>
    </div>
    <div slot="content" class="wrapper-padding">
      <el-form :model="passWordForm" :rules="rules" ref="passForm" label-width="120px" class="demo-ruleForm resetPassword-ruleForm">
        <el-form-item :label="attrText.password" prop="pass">
          <el-input type="password" v-model="passWordForm.pass" auto-complete="off" :placeholder="attrText.password"></el-input>
          <translate v-show="show_password_warning && company_password_strength == 1">The administrator has enabled the password strength setting. The password must be at least 6 characters long and must contain two of uppercase letters, lowercase letters, and special characters.</translate>
          <translate v-show="show_password_warning && company_password_strength == 2">The administrator has enabled the password strength setting. The password must be at least 8 characters long and must contain uppercase letters, lowercase letters, and special characters.</translate>
        </el-form-item>
        <el-form-item :label="attrText.repeatpass" prop="checkPass">
          <el-input type="password" v-model="passWordForm.checkPass" auto-complete="off" :placeholder="attrText.repeatpass"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="detail-btn">
      <div class="btn-wrapper">
        <el-button type="primary" @click="onSubmitForm('passForm')">
          <translate>Save</translate>
        </el-button>
        <el-button @click="$refs.rightPanel.onClose()">
          <translate>Cancel</translate>
        </el-button>
      </div>
    </div>
  </right-panel>
</template>

<script>
  import STORE_CONST from '../../../store/consts'
  import RightPanel from '../../common/right-panel'
  import {PasswordStrengthRegExp, PasswordStrengthRegExpCallback} from '../../../config'
  export default{
    name: 'AccountChangePassword',
    props: {
      items: {
        required: true
      }
    },
    data () {
      // check password
      let pass = (rule, value, callback) => {
        let level = this.company_password_strength
        var uppercasePattern = PasswordStrengthRegExp.uppercasePattern
        var lowercasePattern = PasswordStrengthRegExp.lowercasePattern
        var sysbolPattern = PasswordStrengthRegExp.sysbolPattern
        var uppercaseRes = uppercasePattern.test(value)
        var lowercaseRes = lowercasePattern.test(value)
        var sysbolRes = sysbolPattern.test(value)
        if (value.length) {
          if (level === 1) {
            if (value.length >= 6 && ((lowercaseRes && uppercaseRes) || (lowercaseRes && sysbolRes) || (uppercaseRes && sysbolRes))) {
              callback()
            } else {
              this.show_password_warning = false
              callback(new Error(this.$gettext(PasswordStrengthRegExpCallback.level1_msg)))
            }
          } else if (level === 2) {
            if (value.length >= 8 && lowercaseRes && uppercaseRes && sysbolRes) {
              callback()
            } else {
              this.show_password_warning = false
              callback(new Error(this.$gettext(PasswordStrengthRegExpCallback.level2_msg)))
            }
          } else { // level为0
            callback()
          }
        } else {
          callback(new Error(this.$gettext('Please enter your password!')))
        }
        if (this.passWordForm.checkPass !== '') {
          this.$refs.passForm.validateField('checkPass')
        }
      }
      let checkPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$gettext('Please enter your password again!')))
        } else if (value !== this.passWordForm.pass) {
          callback(new Error(this.$gettext('Two passwords are not consistent!')))
        } else {
          callback()
        }
      }
      return {
        connects: null,
        passWordForm: {
          pass: '',
          checkPass: ''
        },
        rules: {
          pass: [
            {validator: pass, trigger: 'change'}
          ],
          checkPass: [
            {validator: checkPass, trigger: 'change'}
          ]
        },
        company_password_strength: this.$store.getters.team.setting.password_strength || 0,
        show_password_warning: this.$store.getters.team.setting.password_strength !== '0'
      }
    },
    computed: {
      attrText () {
        return this.getTranslateText()
      }
    },
    methods: {
      // 提取翻译文本
      getTranslateText () {
        return {
          password: this.$gettext('Password'),
          repeatpass: this.$gettext('repeat password')
        }
      },
      // 确定提交修改密码
      onSubmitForm (formName) {
        let params = {
          data: {
            pwd: this.passWordForm.pass
          }
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$store.dispatch(STORE_CONST.ACCOUNT.UPDATE, params).then(res => {
              this.$refs.rightPanel.onClose()
              this.isShow = false
              this.$store.dispatch(STORE_CONST.ACCOUNT.LOGOUT).then(res => {
                this.$router.push('/login')
                this.$notify({
                  message: this.$gettext('Modify password successfully,Please Re Login'),
                  type: 'success'
                })
              })
            })
          } else {
            return false
          }
        })
      },
      onCloseChange () {
        this.connects = null
        this.$emit('onClosePanel')
      },
      // reset form
      resetForm (formName) {
        this.$refs[formName].resetFields()
      }
    },
    watch: {
      'items': {
        handler: function (newVal) {
          if (this.connects) {
            this.connects = null
            setTimeout(() => {
              this.connects = this.items
            }, 300)
          } else {
            this.connects = this.items
          }
        },
        deep: true
      }
    },
    components: {
      RightPanel
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">
  .resetPassword-ruleForm {
    .is-error {
      margin-bottom: 45px;
    }
  }
</style>



// WEBPACK FOOTER //
// account-change-password.vue?305d8954